export enum LANGUAGE {
    EN = 'en',
    VI = 'vi'
}